export default {
  map: {
    normal: '标准地图',
    blue_night: '蓝夜地图',
    light: '简约地图',
    fresh: '清新地图',
    dark: '黑夜地图',
    search_keyword: '搜索',
    charge_station_status: '电站状态',
    charge_station_attribute: '电站属性',
    service_providers: '运营商',
    advanced_search: '高级搜索',
    detailed_search: '详细搜索',
    open: '对外开放',
    certificated: '是否认证',
    charge_station_region: '充电站地区',
    ge: '个'
  }
}
